/**
 * Set up routing for all Evaluation views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import AuthoringLayout from '../admin/components/AuthoringLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import evaluation views
import AdminEvaluationList from './views/AdminEvaluationList.js.jsx';
import AdminSingleEvaluation from './views/AdminSingleEvaluation.js.jsx';
import AdminUpdateEvaluation from './views/AdminUpdateEvaluation.js.jsx';

class EvaluationAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleEvalUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All evaluations', path:null}]}
          exact
          component={AdminEvaluationList}
          role="admin"
          path="/admin/authoring/evaluations"
        />
        <YTRoute
          breadcrumbs={[{display:'All evaluations', path:'/admin/authoring/evaluations'},{display:'Details',path:null}]}
          exact
          component={AdminSingleEvaluation}
          role="admin"
          path="/admin/authoring/evaluations/:evaluationId"
        />
        <YTRoute
          breadcrumbs={[{display:'All evaluations', path:'/admin/authoring/evaluations'},{display:'Details',path:singleEvalUpdatePath},{display:'Update',path:null}]}
          exact
          component={AdminUpdateEvaluation}
          role="admin"
          path="/admin/authoring/evaluations/:evaluationId/update"
        />
      </Switch>
    )
  }
}

export default withRouter(EvaluationAdminRouter);



// WEBPACK FOOTER //
// modules/evaluation/EvaluationAdminRouter.js.jsx